// extracted by mini-css-extract-plugin
export default {"errorMessage":"page_errorMessage__UF7CL","message":"page_message__miJ8K"};